export default "__VITE_ASSET__D16WYZ6S__"